$(function () {
    window.toaster = (() => {

        function getOrCreateToast() {
            let toastEl = document.getElementById("toast");

            if (!toastEl) {
                toastEl = document.createElement("div");
                toastEl.id = "toast";
                toastEl.className = "toast";
                document.body.appendChild(toastEl);
            }

            return toastEl;
        }

        function show(content, type = "success", duration = 3000) {
            const toastEl = getOrCreateToast();
            if (!toastEl) return;

            // reset state
            toastEl.className = "toast";
            toastEl.innerHTML = "";

            const wrapper = document.createElement("div");
            wrapper.className = "toast-content";

            // icon
            const icon = document.createElement("span");
            icon.className = "toast-icon";
            icon.innerHTML = type === "success" ? '<svg><use href="/dist/img/svg-sprite.svg#tick"></use></svg>' : '<svg><use href="/dist/img/svg-sprite.svg#x"></use></svg>';
            wrapper.appendChild(icon);

            // content
            if (content instanceof HTMLElement) {
                wrapper.appendChild(content.cloneNode(true));
            } else {
                const text = document.createElement("span");
                text.className = "toast-text";
                text.textContent = content;
                wrapper.appendChild(text);
            }

            toastEl.appendChild(wrapper);
            toastEl.classList.add(type, "show");

            // auto hide
            setTimeout(() => {
                toastEl.classList.remove("show");
                toastEl.classList.add("hide");
            }, duration);
        }

        return {
            success: (content, duration) => show(content, "success", duration),
            error: (content, duration) => show(content, "error", duration),
            show
        };
    })();
});